import { checkURVGreaterThanLRV } from 'helpers/Validation';
import { paddingLabel } from '../C11/C11.data';
import { labelWidth } from '../P710/P710.data';
import { HMISectionCulatedRangeFormula } from '../P78/P78.formulas';
import { EngineeringUnit } from 'journeys/portal/Forms/Sections.constants';

const lrvLabel = 'Instrument LRV';
const urvLabel = 'Instrument URV';

export const HMISectionDataS81 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'F21HmiLrvLabel',
                label: 'HMI LRV',
                xs: 4,
                isLabel: true,
                fontWeight: '600',
                fontSize: '9pt',
                padding: paddingLabel,
                marginTop: '20px'
            },
            {
                key: 'F21HmiLrv',
                value: selectedTag.DateTested ? formData?.F21HmiLrv : formData?.F21HmiLrv ?? selectedTag?.TsprHmiLrv,
                type: 'number',
                height: '1.2rem',
                xs: 2,
                width: '100%',
                labelWidth: '0',
                textAlign: 'center',
                borderBottom: '0',
                maxLength: '10',
                hasHmiError: !checkURVGreaterThanLRV(formData.F21HmiLrv, formData.F22HmiUrv),
                marginTop: '20px'
            },
            {
                key: 'F22HmiUrvLabel',
                label: 'HMI URV',
                xs: 4,
                isLabel: true,
                labelWidth,
                fontWeight: '600',
                fontSize: '9pt',
                padding: paddingLabel,
                textAlign: 'right',
                marginTop: '20px'
            },
            {
                key: 'F22HmiUrv',
                value: selectedTag.DateTested ? formData.F22HmiUrv : formData.F22HmiUrv ?? selectedTag?.TsprHmiUrv,
                xs: 2,
                width: '100%',
                labelWidth: '0',
                textAlignLabel: 'end',
                height: '1.2rem',
                marginRight: '0.5rem',
                textAlign: 'center',
                type: 'number',
                borderBottom: '0',
                maxLength: '10',
                hasHmiError: !checkURVGreaterThanLRV(formData.F21HmiLrv, formData.F22HmiUrv),
                marginTop: '20px'
            }]
        },
        {
            key: 2,
            fields: [{
                key: 'F23HmiCalculatdRangeLabel',
                label: 'HMI Calculated Range',
                xs: 4,
                isLabel: true,
                fontWeight: '600',
                fontSize: '9pt',
                padding: paddingLabel,
            },
            {
                key: 'F23HmiCalculatdRange',
                value: HMISectionCulatedRangeFormula(formData.F21HmiLrv, formData.F22HmiUrv, formData.F24HmiEngineeringUnit),
                xs: 2,
                isCalculatedNew: true,
                readOnly: true,
                inputWidth: '100%',
                labelWidth: '0',
                borderBottom: '0',
                isAutoGrow: true,
                marginRight: '0',
                borderTop: '0',
                textAlign: 'center'
            },
            {
                key: 'F24HmiEngineeringUnitLabel',
                label: EngineeringUnit.HMI_ENGINEERING_UNIT_EU,
                xs: 4,
                isLabel: true,
                fontWeight: '600',
                fontSize: '9pt',
                labelWidth,
                textAlign: 'right',
                padding: paddingLabel,
            },
            {
                key: 'F24HmiEngineeringUnit',
                value: selectedTag.DateTested ? formData?.F24HmiEngineeringUnit : formData?.F24HmiEngineeringUnit ?? selectedTag?.TsprHmiEngineeringUnits,
                xs: 2,
                inputWidth: '100%',
                labelWidth: '0%',
                textAlignLabel: 'end',
                isAutoGrow: true,
                marginRight: '0.5rem',
                textAlign: 'center',
                maxLength: '14',
                direction: 'rtl',
            }]
        },
        {
            key: 3,
            fields: [
                {
                    key: 'F25InstrumentLrvLabel',
                    label: lrvLabel,
                    xs: 4,
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                    padding: paddingLabel,
                },
                {
                    key: 'F25InstrumentLrv',
                    value: selectedTag.DateTested ? formData?.F25InstrumentLrv : formData?.F25InstrumentLrv ?? selectedTag?.TsprInstrumentCalibratedLrv,
                    type: 'number',
                    xs: 2,
                    width: '100%',
                    labelWidth: '0',
                    height: '1.3rem',
                    textAlign: 'center',
                    maxLength: '10',
                    borderBottom: '0',
                    borderTop: '0',
                    hasInstError: !checkURVGreaterThanLRV(formData.F25InstrumentLrv, formData.F26InstrumentUrv)
                },
                {
                    key: 'F26InstrumentUrvLabel',
                    label: urvLabel,
                    xs: 4,
                    isLabel: true,
                    fontWeight: '600',
                    labelWidth,
                    fontSize: '9pt',
                    textAlign: 'right',
                    padding: paddingLabel,
                },
                {
                    key: 'F26InstrumentUrv',
                    value: selectedTag.DateTested ? formData?.F26InstrumentUrv : formData?.F26InstrumentUrv ?? selectedTag?.InstrumentCalibratedUrv,
                    type: 'number',
                    xs: 2,
                    width: '100%',
                    labelWidth: '0%',
                    textAlignLabel: 'end',
                    height: '1.2rem',
                    marginRight: '0.5rem',
                    textAlign: 'center',
                    borderBottom: '0',
                    maxLength: '10',
                    hasInstError: !checkURVGreaterThanLRV(formData.F25InstrumentLrv, formData.F26InstrumentUrv)
                }]
        },
        {
            key: 4,
            fields: [
                {
                    key: 'F27InstrumentCalculatedRangeLabel',
                    label: 'Instrument Calculated Range',
                    xs: 4,
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                    padding: paddingLabel,
                },
                {
                    key: 'F27InstrumentCalculatedRange',
                    value: HMISectionCulatedRangeFormula(formData.F25InstrumentLrv, formData.F26InstrumentUrv, formData.F28InstrumentEngineeringUnit),
                    xs: 2,
                    isCalculatedNew: true,
                    readOnly: true,
                    inputWidth: '100%',
                    labelWidth: '0%',
                    borderTop: '0',
                    textAlign: 'center',
                    marginBottom: '18px',
                    height: '2rem',
                    isAutoGrow: 'true',
                    maxLength: '55',
                    marginRight: '0',
                },
                {
                    key: 'F28InstrumentEngineeringUnitLabel',
                    label: EngineeringUnit.INSTRUMENT_ENGINEERING_UNIT_EU,
                    xs: 4,
                    isLabel: true,
                    labelWidth,
                    fontWeight: '600',
                    fontSize: '9pt',
                    textAlign: 'right',
                    padding: paddingLabel,
                },
                {
                    key: 'F28InstrumentEngineeringUnit',
                    value: selectedTag.DateTested ? formData?.F28InstrumentEngineeringUnit : formData?.F28InstrumentEngineeringUnit ?? selectedTag?.TsprInstrumentEngineeringUnits,
                    xs: 2,
                    textAlignLabel: 'end',
                    maxLength: '17',
                    inputWidth: '100%',
                    labelWidth: '0%',
                    borderTop: '0',
                    marginRight: '0.5rem',
                    isAutoGrow: true,
                    marginBottom: '18px',
                    textAlign: 'center',
                    direction: 'rtl',
                }]
        }]
});
